import * as React from "react";
const SvgFiRrOmega = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-omega_svg__a)">
      <path
        fill="#062147"
        d="M23 24h-5.36A2.644 2.644 0 0 1 15 21.36c0-1.028.598-1.964 1.522-2.385C19.901 17.437 22 14.38 22 10.999c0-4.962-4.486-9-10-9S2 6.038 2 11c0 3.381 2.099 6.438 5.478 7.976A2.62 2.62 0 0 1 9 21.361a2.643 2.643 0 0 1-2.639 2.64H1a1 1 0 1 1 0-2h5.361a.64.64 0 0 0 .639-.64.61.61 0 0 0-.351-.564C2.547 18.929 0 15.175 0 11 0 4.935 5.383 0 12 0s12 4.935 12 11c0 4.175-2.548 7.929-6.649 9.796a.62.62 0 0 0-.351.564c0 .353.287.64.64.64H23a1 1 0 1 1 0 2"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-omega_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrOmega;
